import api from '../../../utils/api';

export interface ScholarshipStage {
  id: number;
  stageOrder: number;
  stageName: string;
  requiredRole: string;
  actionLabel: string;
  rejectLabel: string;
  isFinalStage: boolean;
  hasUsersAssigned: boolean;
}

export interface ScholarshipStagePayload {
  stageOrder: number;
  stageName: string;
  requiredRole: string;
  actionLabel: string;
  rejectLabel: string;
  isFinalStage: boolean;
}

export const getScholarshipStages = async () => {
  return (await api.get('/admin/scholarship/stage-config'))?.data as APIResponse<ScholarshipStage[]>;
};

export const configureScholarshipStages = async (payload: ScholarshipStagePayload[]) => {
  return (await api.post('/admin/scholarship/stage-config', payload))?.data as APIResponse<any>;
};
